'use client';

import { useState, useEffect } from 'react';
import Image from 'next/image';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Services', href: '#services' },
    { label: 'Gallery', href: '#gallery' },
    { label: 'Reviews', href: '#reviews' },
    { label: 'Contact', href: '#contact' },
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-black/95 backdrop-blur-md shadow-lg shadow-accent/10' : 'bg-transparent'}`}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-20 sm:h-24">
          {/* Logo */}
          <a href="/" className="flex items-center group">
            <Image
              src="/assets/images/FIGURE_8_LOGO_v1.5-1783562563632.png"
              alt="Figure 8 Detailing Logo"
              width={420}
              height={147}
              className="h-24 sm:h-36 w-auto object-contain group-hover:opacity-90 transition-opacity"
              priority
            />
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks?.map(link => (
              <a key={link?.label} href={link?.href} className="hover:text-accent transition-colors text-sm font-medium tracking-wide text-neutral-50">
                {link?.label}
              </a>
            ))}
            <a href="tel:6198838807" className="bg-accent hover:bg-accent-dark text-white font-bold px-5 py-2 rounded-full text-sm transition-all hover:scale-105 shadow-md shadow-accent/30">
              (619) 883-8807
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            className="md:hidden text-silver-DEFAULT p-2"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <div className="w-6 flex flex-col gap-1.5">
              <span className={`block h-0.5 bg-silver-DEFAULT transition-all ${menuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
              <span className={`block h-0.5 bg-silver-DEFAULT transition-all ${menuOpen ? 'opacity-0' : ''}`}></span>
              <span className={`block h-0.5 bg-silver-DEFAULT transition-all ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
            </div>
          </button>
        </div>

        {/* Mobile Menu */}
        {menuOpen && (
          <div className="md:hidden bg-black/98 backdrop-blur-md border-t border-accent/20 py-4">
            {navLinks?.map(link => (
              <a
                key={link?.label}
                href={link?.href}
                className="block px-4 py-3 text-silver-DEFAULT hover:text-accent transition-colors font-medium"
                onClick={() => setMenuOpen(false)}
              >
                {link?.label}
              </a>
            ))}
            <div className="px-4 pt-3 pb-1">
              <a href="tel:6198838807" className="block text-center bg-accent hover:bg-accent-dark text-white font-bold px-5 py-3 rounded-full text-sm transition-all shadow-md shadow-accent/30">
                Call (619) 883-8807
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
